/*
 * Uppercase section / column header.
 */
import { styled } from '@mui/material/styles';

const GpColumnHeader = styled('h2')({
  font: '500 14px/1.2 var(--gp-font)',
  letterSpacing: 0.8,
  textTransform: 'uppercase',
  color: 'var(--gp-ink-mute)',
  margin: '0 0 14px',
});

export default GpColumnHeader;
